import { createAction } from '@reduxjs/toolkit'

import { TSubTaskResponse, TTaskResponse } from 'redux/api/Tasks'

// tryGetAllTasks
export const getAll = createAction('get_all_tasks')
export const getAllSuccess = createAction<{ data: TTaskResponse[] }>(
  'get_all_tasks_success'
)
export const getAllFailed = createAction('get_all_tasks_failed')

// tryCreateTask
export const create = createAction('create_task')
export const createSuccess = createAction<{
  data: TTaskResponse | TSubTaskResponse
}>('create_task_success')
export const createFailed = createAction('create_task_failed')

// tryUpdateTask
export const update = createAction('update_task')
export const updateSuccess = createAction<{
  data: TTaskResponse | TSubTaskResponse
}>('update_task_success')
export const updateFailed = createAction('update_task_failed')

// tryDeleteTask
export const destroy = createAction('delete_task')
export const destroySuccess = createAction<string>('delete_task_success')
export const destroyFailed = createAction('delete_task_failed')
